import { styled } from '@linaria/react';
import { Button } from '../Button';
export const MOBILE_HEADER_HEIGHT = 65;
export const HeaderElement = /*#__PURE__*/styled('header')({
  name: "HeaderElement",
  class: "h16agnr7",
  propsAsIs: false
});
export const HeaderTopContentElement = /*#__PURE__*/styled('div')({
  name: "HeaderTopContentElement",
  class: "hxymbdq",
  propsAsIs: false
});
export const logoStyles = "l1txxur4";
const _exp10 = /*#__PURE__*/() => Button;
export const BackButtonElement = /*#__PURE__*/styled(_exp10())({
  name: "BackButtonElement",
  class: "b1ym39o5",
  propsAsIs: true
});
export const CenterContentWrapper = /*#__PURE__*/styled('div')({
  name: "CenterContentWrapper",
  class: "c1fqef21",
  propsAsIs: false
});
export const Spacer = /*#__PURE__*/styled('div')({
  name: "Spacer",
  class: "s1az7d09",
  propsAsIs: false
});
export const EndContentWrapper = /*#__PURE__*/styled('div')({
  name: "EndContentWrapper",
  class: "e1hv86r5",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");